import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Grid, TextField, MenuItem, Button
} from '@mui/material';

export default function PayPeriodFormDialog({
  open, onClose, onSubmit,
  mode, formData, setFormData,
  periodTypeLabels, selectedPeriod
}) {
  const isCreate = mode === 'create';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isCreate ? 'Create Pay Period' : 'Edit Pay Period'}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label={isCreate ? 'Period Name (Optional)' : 'Period Name'}
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            fullWidth
            helperText={isCreate ? 'Leave blank to auto-generate based on dates' : undefined}
          />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Start Date"
                type="date"
                value={formData.start_date}
                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                fullWidth
                required={isCreate}
                InputLabelProps={{ shrink: true }}
                disabled={!isCreate && selectedPeriod?.status !== 'open'}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="End Date"
                type="date"
                value={formData.end_date}
                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                fullWidth
                required={isCreate}
                InputLabelProps={{ shrink: true }}
                disabled={!isCreate && selectedPeriod?.status !== 'open'}
              />
            </Grid>
          </Grid>
          {isCreate && (
            <TextField
              select
              label="Period Type"
              value={formData.period_type}
              onChange={(e) => setFormData({ ...formData, period_type: e.target.value })}
              fullWidth
            >
              {Object.entries(periodTypeLabels).map(([value, label]) => (
                <MenuItem key={value} value={value}>{label}</MenuItem>
              ))}
            </TextField>
          )}
          <TextField
            label={isCreate ? 'Notes (Optional)' : 'Notes'}
            value={formData.notes}
            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            fullWidth
            multiline
            rows={2}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={isCreate && (!formData.start_date || !formData.end_date)}
        >
          {isCreate ? 'Create' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
